import React from "react";
import { observer, inject } from 'mobx-react';
import {
    Grid,
    CircularProgress,
    Tabs,
    Tab,
    Dialog,
    DialogTitle,
    DialogContent,
    Collapse,
    Paper,
    Divider
} from "@material-ui/core";
import { InviteByEmailForm, InviteByLinkForm } from "./components/Forms/Index";
import SharedUser from "./components/SharedUser";
import InviteLink from "./components/InviteLink";

function SharePopup({ store }) {
    const [value, setValue] = React.useState(0);
    let Cmp;

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderInviteAction = () => {
        if (store?.isLoading) return null;

        return (
            <div style={{ padding: 16 }}>
                <Paper elevation={2}>
                    <Grid item xs={12} className="invite_form_tabs">
                        <Tabs
                            value={value}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleChange}
                        >
                            <Tab label="Invite By Email" />
                            <Tab label="Invite By Link" />
                        </Tabs>
                        <TabPanel value={value} index={0}>
                            <InviteByEmailForm
                                activeUsers={store.activeUsers}
                                loadingRoles={[...store.loadingRoles]}//todo check this, set update is not triggered.
                                roles={store.roles}
                                store={store}
                                onSubmit={store.handleAddUsersToRole}
                                onRoleCreate={store.handleCreateRole}
                                onRoleDelete={store.handleDeleteRole}
                            />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <InviteByLinkForm
                                activeUsers={store.activeUsers}
                                loadingRoles={[...store.loadingRoles]}//todo check this, set update is not triggered.
                                roles={store.roles}
                                store={store}
                                onSubmit={store.handleSaveInvite}
                                onRoleCreate={store.handleCreateRole}
                                onRoleDelete={store.handleDeleteRole}
                            />
                        </TabPanel>
                    </Grid>
                </Paper>
            </div>
        );
    };

    const renderShareDialogContent = () => {
        if (store?.isLoading) {
            return <CircularProgress size={20} />;
        }

        return (
            <Grid>
                {store.inviteLinks.length > 0 && (
                    <React.Fragment>
                        <div>
                            <span className="dialog_subtitle">Invite links </span>
                            {store.isSharedUsersLoading && <CircularProgress size={20} />}
                        </div>
                        <Grid item xs={12}
                            style={{
                                marginTop: 20,
                                // maxHeight: 300,
                                overflow: 'auto',
                            }}
                        >
                            {store.inviteLinks.map((inviteLink) => {
                                return (
                                    <InviteLink
                                        key={inviteLink.id}
                                        data={inviteLink}
                                        roles={[...store.roles]}
                                        onDelete={store.handleSaveInvite}
                                        onUpdate={store.handleSaveInvite}
                                    // isSaving={store.savingUserEmails.has(user.email)}
                                    />
                                );
                            })}
                        </Grid>
                    </React.Fragment>
                )}
                <div>
                    <span className="dialog_subtitle">Shared Users </span>
                    {store.isSharedUsersLoading && <CircularProgress size={20} />}
                </div>
                <Grid item xs={12} style={{ marginTop: 20 }}>
                    {store.sharedUsers.map((user) => {
                        return (
                            <SharedUser
                                key={user.id}
                                data={user}
                                roles={[...store.roles]}
                                onDelete={store.handleDeleteUserRole}
                                onUpdate={store.handleUpdateUserRole}
                                isSaving={store.savingUserEmails.has(user.email)}
                            />
                        );
                    })}
                </Grid>
            </Grid>
        );
    }

    return (
        <div>
            <Dialog
                open={Boolean(store.anchorEl)}
                onClose={store.handleClose}
                scroll={"paper"}
                aria-labelledby="scroll-dialog-title"
                disableEnforceFocus // issue fix with extjs input boxes focus.
                PaperProps={
                    {
                        style: {
                            // padding: 20,
                            minWidth: 800,
                            maxHeight: "90vh",
                        }
                    }
                }
                TransitionComponent={Collapse}
            >
                <DialogTitle>Share Pack</DialogTitle>
                <Divider />
                {renderInviteAction()}
                <DialogContent>{renderShareDialogContent()}</DialogContent>
            </Dialog>
        </div>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

export default inject('store')(observer(SharePopup));